import { useState } from "react";
import { Button, IconProvider } from "../ui";

import { usePlatformTranslation } from '@/hooks/usePlatformTranslation';
interface SubscribeStep2Props {
  email: string;
  onNext: (firstname: string, lastname: string, jobTitle: string, company: string) => void;
}

const SubscribeStep2: React.FC<SubscribeStep2Props> = ({ email, onNext }) => {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [company, setCompany] = useState("");
  const [errors, setErrors] = useState<{[key: string]: string}>({});

  const validateFields = () => {
  const { t } = usePlatformTranslation();
    const newErrors: {[key: string]: string} = {};
    
    if (!firstname.trim()) {
      newErrors.firstname = "First name is required";
    }
    if (!lastname.trim()) {
      newErrors.lastname = "Last name is required";
    }
    if (!jobTitle.trim()) {
      newErrors.jobTitle = "Job title is required";
    }
    if (!company.trim()) {
      newErrors.company = "Company name is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (validateFields()) {
      onNext(firstname, lastname, jobTitle, company);
    }
  };

  const isFormValid = firstname.trim() && lastname.trim() && jobTitle.trim() && company.trim();

  return (
    <>
      {
        <div>
          <h4 className="header-4 text-left text-gray-900 mb-2"> Great! Lets get to know you better</h4>
          <p className="text-left text-gray-900 mb-4 text-sm">
            You are signing up with <strong>{email}</strong>
          </p>
        </div>
      }

      <div className="flex flex-col gap-2 w-full">
        <div className="flex  flex-col sm:flex-row gap-4 w-full">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex flex-col">
              <p className="text-sm text-gray-900">{t('platform.subscribe_Parts.step2.first_name')}</p>
              <input
                type="text"
                value={firstname}
                onChange={(e) => {
                  setFirstname(e.target.value);
                  if (errors.firstname) {
                    setErrors(prev => ({ ...prev, firstname: "" }));
                  }
                }}
                placeholder={t('platform.subscribe_Parts.step2.first_name_placeholder')}
                required
                className={`w-full h-8 px-4 border rounded-sm focus:outline-none focus:ring-2 focus:ring-purple-1 focus:border-transparent ${
                  errors.firstname ? "border-red-500" : "border-gray-300"
                }`}
              />
              {errors.firstname && (
                <p className="text-red-500 text-xs mt-1">{errors.firstname}</p>
              )}
            </div>
          </div>
          <div className="flex flex-col">
            <p className="text-sm text-gray-900">{t('platform.subscribe_Parts.step2.last_name')}</p>
            <input
              type="text"
              value={lastname}
              onChange={(e) => {
                setLastname(e.target.value);
                if (errors.lastname) {
                  setErrors(prev => ({ ...prev, lastname: "" }));
                }
              }}
              placeholder={t('platform.subscribe_Parts.step2.last_name_placeholder')}
              required
              className={`w-full h-8 px-4 border rounded-sm focus:outline-none focus:ring-2 focus:ring-purple-1 focus:border-transparent ${
                errors.lastname ? "border-red-500" : "border-gray-300"
              }`}
            />
            {errors.lastname && (
              <p className="text-red-500 text-xs mt-1">{errors.lastname}</p>
            )}
          </div>
        </div>
        <div className="flex flex-col">
          <p className="text-sm text-gray-900">{t('platform.subscribe_Parts.step2.job_title')}</p>
          <input
            type="text"
            value={jobTitle}
            onChange={(e) => {
              setJobTitle(e.target.value);
              if (errors.jobTitle) {
                setErrors(prev => ({ ...prev, jobTitle: "" }));
              }
            }}
            placeholder={t('platform.subscribe_Parts.step2.job_title_placeholder')}
            required
            className={`w-full h-8 px-4 border rounded-sm focus:outline-none focus:ring-2 focus:ring-purple-1 focus:border-transparent ${
              errors.jobTitle ? "border-red-500" : "border-gray-300"
            }`}
          />
          {errors.jobTitle && (
            <p className="text-red-500 text-xs mt-1">{errors.jobTitle}</p>
          )}
        </div>
        <div className="flex flex-col">
          <p className="text-sm text-gray-900">{t('platform.subscribe_Parts.step2.company_name')}</p>
          <input
            type="text"
            value={company}
            onChange={(e) => {
              setCompany(e.target.value);
              if (errors.company) {
                setErrors(prev => ({ ...prev, company: "" }));
              }
            }}
            placeholder={t('platform.subscribe_Parts.step2.company_name_placeholder')}
            required
            className={`w-full h-8 px-4 border rounded-sm focus:outline-none focus:ring-2 focus:ring-purple-1 focus:border-transparent ${
              errors.company ? "border-red-500" : "border-gray-300"
            }`}
          />
          {errors.company && (
            <p className="text-red-500 text-xs mt-1">{errors.company}</p>
          )}
        </div>

        <div>
          <Button
            type="submit"
            variant="default"
            className="w-full mt-4"
            onClick={handleSubmit}
            disabled={!isFormValid}
          >
            Next Step
          </Button>
        </div>
      </div>
    </>
  );
};

export default SubscribeStep2;
